import { Container } from "./styles";

const HighlightBand = ({ children, background = "#28a137" }) => {
  return <Container $background={background}>{children}</Container>;
};

export default HighlightBand;
